import { enumerateStages } from "logic/Navigation/NavigationHelper";
import { getStageKey, Stage } from "logic/Navigation/Stages";
import { getStage, StepId } from "logic/Navigation/Steps";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    currentStep: StepId;
}

const allStages: Stage[] = enumerateStages();

export const BookingStepperMobile: React.FC<Props> = (props: Props) => {
    const currentStage = getStage(props.currentStep);
    const { t } = useTranslation();

    if (currentStage === null) {
        return null;
    }

    return (
        <div className="stepper-container2">
            <p className="stepper-stepname">{t(getStageKey(allStages[currentStage ?? 0]))}</p>
            <div className="stepper-steps">
                {allStages.map((stageId, index) => (
                    <div key={index} className="stepper-step-container">
                        {index < currentStage ? (
                            <>
                                <svg className="step-complete MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-completed" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"></path>
                                </svg>
                                <div
                                    className={"stepper-step" + (index === (currentStage ?? 0) ? " stepper-step--active" : "")}
                                    style={{ position: "absolute", width: "100%" }}
                                ></div>
                            </>
                        ) : (
                            <span className={"stepper-step" + (index === (currentStage ?? 0) ? " stepper-step--active" : "")} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
